module.exports = __webpack_public_path__ + "f2f88e1930391095cc20f86f13d196fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/intuit_2022_chart.png
// module id = 1689
// module chunks = 0